import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]
  static values  = { autoOpen: { type: Boolean, default: false } }

  connect() {
    this._openHandler = this.open.bind(this)
    document.addEventListener("instructions:open", this._openHandler)
    if (this.autoOpenValue) this.open()
  }

  disconnect() {
    document.removeEventListener("instructions:open", this._openHandler)
  }

  open(event) {
    if (event?.preventDefault) event.preventDefault()
    this.panelTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close(event) {
    if (event?.preventDefault) event.preventDefault()
    this.panelTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    fetch("/instructions/dismiss", {
      method: "POST",
      headers: { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content }
    })
  }
}
